import Glider from 'glider-js';
import $ from 'jquery';
import { MQ } from '../tools/MQ.js';

export const init = () => {
	const map = document.querySelector('.eco-map__map-wrap');
	var point = null;
	const mapConfig = document.querySelector('.js-eco-map-config');
	if (mapConfig) {
		const imgMap = mapConfig.querySelector('img');
		imgMap.onclick = setPoint;
		function setPoint(e) {
			const mapRect = this.getBoundingClientRect();
			const mapTop = document.querySelector('.js-eco-point-top'),
				mapLeft = document.querySelector('.js-eco-point-left');
			var offset = {
				top: mapRect.top + window.pageYOffset,
				left: mapRect.left + window.pageXOffset,
			};
			var relativeX = e.pageX - offset.left;
			var relativeY = e.pageY - offset.top;
			const clickWidth = ((relativeX / imgMap.clientWidth) * 100).toFixed(2) + '%';
			const clickHeight = ((relativeY / imgMap.clientHeight) * 100).toFixed(2) + '%';
			if (point) {
				point.remove();
			}
			point = document.createElement('span');
			point.setAttribute('class', 'eco-map__point-fake');
			point.setAttribute('style', 'top: ' + clickHeight + '; left:' + clickWidth + ';');
			mapConfig.appendChild(point);
			mapTop.value = clickHeight;
			mapLeft.value = clickWidth;
		}
	}

	const jsArticleCarousel = Array.from(document.querySelectorAll('.js-eco-map-slider'));

	jsArticleCarousel.forEach((item, index) => {
		const prevControl = item.nextElementSibling.querySelector('.slider-control__arrow-prev');
		const nextControl = item.nextElementSibling.querySelector('.slider-control__arrow-next');
		const points = Array.from(document.querySelectorAll('.js-eco-map-point'));

		function setPoint(event) {
			let items = Array.from(document.querySelectorAll('.eco-map__item'));
			items.forEach((item) => {
				if (item.classList.contains('active')) {
					const ind = items.indexOf(item);
					points.forEach((point, index) => {
						point.classList.remove('is-active');
						if (index === ind) {
							point.classList.add('is-active');
						}
					});
				}
			});
		}
		function scrollToItem(event) {
			event.preventDefault();
			points.forEach((point) => {
				point.classList.remove('is-active');
				if (this === point) {
					point.classList.add('is-active');
					const ind = points.indexOf(point);
					glider.scrollItem(ind);
				}
			});
		}

		var glider = new Glider(item, {
			slidesToShow: 1,
			slidesToScroll: 1,
			scrollLock: true,
			draggable: true,
			dots: false,
			arrows: {
				prev: prevControl,
				next: nextControl,
			},
		});
		document.addEventListener('glider-animated', setPoint);
		$('.js-eco-map-point').on('click', scrollToItem);
	});
};
